import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAtom, useAtomValue, useSelectors } from '@exodus/headless-ui';
import { formatAssetAmount, formatPrice } from '@exodus/formatting';
import { fiatModeAtom, fromAmountAtom, fromAssetAtom, fromFiatAmountAtom, isFromLoadingAtom, } from '../../../atoms/index.js';
const FromAssetValue = ({ Component, className, style, onPress, }) => {
    const selectors = useSelectors();
    const fromAsset = useAtomValue(fromAssetAtom);
    const fromAmount = useAtomValue(fromAmountAtom);
    const fromFiatAmount = useAtomValue(fromFiatAmountAtom);
    const isLoading = useAtomValue(isFromLoadingAtom);
    const [fiatMode, setFiatMode] = useAtom(fiatModeAtom);
    const currency = useSelector(selectors.locale.currency);
    const handleToggle = useCallback(() => {
        setFiatMode((value) => !value);
        onPress?.();
    }, [onPress, setFiatMode]);
    const formattedValue = fiatMode
        ? `${formatAssetAmount(fromAmount)} ${fromAsset.displayTicker}`
        : formatPrice(fromFiatAmount.toDefaultNumber(), { currency });
    const amount = fiatMode ? fromAmount : fromFiatAmount;
    if (Component) {
        return (React.createElement(Component, { amount: amount, formattedValue: formattedValue, loading: isLoading, className: className, style: style, onPress: handleToggle, fiatMode: fiatMode, asset: fromAsset }));
    }
    return null;
};
export default FromAssetValue;
